module.exports = __webpack_public_path__ + "static/media/medal.808651ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/medal.svg
// module id = 272
// module chunks = 0